import {
  CreateFormDialog,
  CreateFormCancelButton,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';
import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import React from 'react';
import { CheckCircle2, Cog, Mail } from '../../../../shared/assets/AppIcons';

import { Label } from '@/shared/ui/label';
import { Textarea } from '@/shared/ui/textarea';

export default function RequestCustomAutomationDialog({
  open,
  onOpenChange,
  request,
  onFieldChange,
  onSubmit,
  submitted,
}) {
  return (
    <CreateFormDialog
      open={open}
      onOpenChange={onOpenChange}
      icon={Cog}
      title="Richiedi Automazione Personalizzata"
    >
      {!submitted ? (
        <div className="mt-4 space-y-4">
          <p className="text-sm text-[var(--text-secondary)]">
            Hai un'idea per un'automazione su misura? Questa area e una demo locale: la richiesta non viene
            inviata a un workflow reale.
          </p>

          <div data-form-field="description">
            <Label htmlFor="descrizione">Descrizione *</Label>
            <Textarea
              id="descrizione"
              placeholder="Descrivi brevemente l'automazione che vorresti..."
              value={request.descrizione}
              onChange={(event) => onFieldChange('descrizione', event.target.value)}
              className="mt-1 min-h-20 resize-none"
            />
          </div>

          <div>
            <Label htmlFor="funzionalita">Funzionalita</Label>
            <Textarea
              id="funzionalita"
              placeholder="Quali funzionalita specifiche dovrebbe avere?"
              value={request.funzionalita}
              onChange={(event) => onFieldChange('funzionalita', event.target.value)}
              className="mt-1 min-h-20 resize-none"
            />
          </div>

          <div>
            <Label htmlFor="obiettivo">Obiettivo</Label>
            <Textarea
              id="obiettivo"
              placeholder="Quale problema vuoi risolvere o quale obiettivo vuoi raggiungere?"
              value={request.obiettivo}
              onChange={(event) => onFieldChange('obiettivo', event.target.value)}
              className="mt-1 min-h-20 resize-none"
            />
          </div>

          <div className="bg-[var(--primary-soft)] border border-[var(--border-strong)] rounded-lg p-3">
            <div className="flex items-start gap-2">
              <Mail className="text-[var(--primary)] mt-0.5" size={16} />
              <div>
                <p className="text-sm font-medium text-[var(--primary)]">Simulazione locale</p>
                <p className="text-xs text-[var(--primary)]">
                  Il contenuto resta locale alla demo e non produce contatti o preventivi reali.
                </p>
              </div>
            </div>
          </div>

          <FormFooterAction>
            <div className="form-footer-actions">
              <CreateFormCancelButton onClick={() => onOpenChange(false)} type="button">
                Annulla
              </CreateFormCancelButton>
              <CreateFormSubmitButton onClick={onSubmit} disabled={!request.descrizione.trim()} type="button">
                Invia Richiesta
              </CreateFormSubmitButton>
            </div>
          </FormFooterAction>
        </div>
      ) : (
        <div className="mt-4 py-8 text-center">
          <div className="w-16 h-16 bg-[var(--success-soft)] rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="text-[var(--success-text)]" size={32} />
          </div>
          <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">Richiesta Inviata!</h3>
          <p className="text-sm text-[var(--text-secondary)]">
            La richiesta personalizzata e stata registrata solo nella demo locale del modulo.
          </p>
        </div>
      )}
    </CreateFormDialog>
  );
}
